import { render, staticRenderFns } from "./EstadoEventoBadge.vue?vue&type=template&id=3a92ae00"
import script from "./EstadoEventoBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./EstadoEventoBadge.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports